import { render, staticRenderFns } from "./selectBirthday.vue?vue&type=template&id=3062a941&"
import script from "./selectBirthday.vue?vue&type=script&lang=ts&"
export * from "./selectBirthday.vue?vue&type=script&lang=ts&"
import style0 from "./selectBirthday.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports